<template>
  <div v-if="order && order.consigneeInfo" :class="_.block">
    <!-- 收件人 -->
    <div :class="_.consignee">
      <img :src="require('./images/地址.png')" :class="_.icon" />
      <div :class="_.content">
        <div :class="_.user">
          <div :class="_.name">{{ order.consigneeInfo.name }}</div>
          <div :class="_.phone">{{ order.consigneeInfo.tel }}</div>
        </div>
        <div :class="_.address">
          {{
            `${order.consigneeInfo.province}${order.consigneeInfo.city}${order.consigneeInfo.area}${order.consigneeInfo.address}`
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      order: {
        type: Object,
        required: true,
      },
    },
  })
</script>

<style lang="scss" module>
  .block {
    margin-top: 12px;
    padding: 12px;
    background: #ffffff;
    border-radius: 8px;
  }

  .express {
    display: flex;
    align-items: flex-start;
    padding-bottom: 12px;
    margin-bottom: 12px;

    .icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      padding-top: 2px;
    }

    .content {
      flex-grow: 1;
      margin-left: 8px;

      .title {
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      .desc {
        font-size: 12px;
        color: #222222;
        line-height: 16px;

        &:not(:first-child) {
          margin-top: 4px;
        }
      }

      .time {
        margin-top: 8px;
        font-size: 12px;
        color: #888888;
        line-height: 16px;
      }
    }

    .arrow {
      flex-shrink: 0;
      margin-left: 23px;
      align-self: center;
      font-size: 14px;
      color: #666;
    }
  }

  .consignee {
    display: flex;
    align-items: flex-start;

    .icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      padding-top: 2px;
    }

    .content {
      flex-grow: 1;
      margin-left: 8px;

      .user {
        display: flex;
        align-items: center;

        .name {
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }

        .phone {
          margin-left: 8px;
          font-size: 14px;
          color: #888888;
          line-height: 20px;
        }
      }

      .address {
        margin-top: 6px;
        font-size: 12px;
        color: #222222;
        line-height: 16px;
      }
    }
  }
</style>
